<template>
  <div :class="cn(cardVariants({ expired }), props.class)">
    <div class="flex gap-2 items-center">
      <FileType
        size="sm"
        variant="solid"
        :extension="item.file.name.split('.').pop()"
      />
      <div class="text-primary text-lg font-medium truncate w-full">
        {{ item.file.name }}
      </div>
    </div>

    <div class="flex w-full gap-6 justify-between items-center">
      <div class="flex items-center overflow-hidden">
        <div>
          <Visibility :is-private="!item.public" :icon-only="true" />
        </div>
        <div class="flex w-full truncate">
          <div class="shrink-0 flex items-center">
            <Divider orientation="vertical" class="h-5.5" />
            {{ item.tenant.name }}
          </div>
          <div
            v-if="!isEmpty(item.spaces)"
            class="w-full truncate flex items-center"
          >
            <Divider orientation="vertical" class="h-5.5" />
            <div class="w-full truncate">
              {{ parseSpaces(item.spaces) }}
            </div>
          </div>
        </div>
      </div>
      <div class="shrink-0">
        <DueDate
          :dueDate="item.expiration_date"
          :isOverdue="expired"
          size="md"
          :placeholder="$t('components.buttons.exp_date')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { isEmpty } from "lodash";

// Import Components
import { FileType } from "@/SharedComponents/File";
import { Visibility } from "@/SharedComponents/Badges";
import { DueDate } from "@/SharedComponents/Dates";
import { Divider } from "@/SharedComponents/Divider";

// Utils
import { parseSpaces } from "@/Utils/linked_to";
import { cn } from "@/Utils/cn";

import { cardVariants } from ".";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  class: {
    type: null,
    required: false,
  },
});

const expired = computed(() => {
  return (
    props.item.expiration_date &&
    Date.now() > new Date(props.item.expiration_date).getTime()
  );
});
</script>
